<div class="hm-rel-date-sel">
  <div class="hm-dialog-header">
    <div class="hm-dialog-header-content">
      <div class="hm-dialog-caption">Response Cut-off</div>
      <div class="hm-dialog-title">Set response cut-off</div>
    </div>
    <button mat-icon-button class="hm-close-button" (click)="onClose()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="hm-options-card">
    <div class="hm-rel-date-list vertical">
    <div class="hm-rel-date-item" *ngFor="let d of availableOptions" (click)="selectRelativeDays(d)" [class.active]="selectedOption===d">
      <div class="hm-radio"></div>
      <div class="hm-rel-date-icon">
        <div class="hm-cal">
          <img src="assets/icons/relative-date-calendar.svg" alt="calendar">
        </div>
      </div>
      <div class="hm-rel-date-text">
        <div class="hm-rel-date-title">{{ formatDayCount(d) }}</div>
        <div class="hm-rel-date-sub">{{ formatDateWithTime(getOptionDateWithTime(d)) }}</div>
      </div>
    </div>

    <div class="hm-rel-date-item" (click)="openCustomPicker()" [class.active]="selectedOption==='custom'">
      <div class="hm-radio"></div>
      <div class="hm-rel-date-icon">
        <div class="hm-cal">
          <img src="assets/icons/relative-date-calendar.svg" alt="calendar">
        </div>
      </div>
      <div class="hm-rel-date-text">
        <div class="hm-rel-date-title">Custom</div>
        <div class="hm-rel-date-sub">Select any day</div>
      </div>
    </div>
    </div>
  </div>

  <div class="hm-summary-row" *ngIf="selectedDate">
    <div class="hm-summary-label">Response cut-off date</div>
    <div class="hm-summary-value">{{ selectedDate | date:'dd MMMM yyyy : hh.mm a' }}</div>
    <div class="hm-summary-icon"></div>
  </div>

  <div *ngIf="showCustomPicker" class="hm-custom-picker">
    <hmt-custom-date-picker
      [singleDateSelection]="true"
      [enableTimeSelection]="true"
      [minDate]="minDate"
      [positionPopupAbove]="true"
      (dateRangeSelected)="onCustomDateSelected($event.startDate)">
    </hmt-custom-date-picker>
  </div>

  <div class="hm-past-datetime-error" *ngIf="pastDateTimeError">
    <mat-icon class="error-icon">error_outline</mat-icon>
    <span>Selected date and time must be in the future</span>
  </div>

  <button mat-raised-button color="primary" class="hm-apply-btn" (click)="onApply()">Apply Dates</button>
</div>


